import { render, staticRenderFns } from "./UserPointManage.vue?vue&type=template&id=41f5b144&scoped=true"
import script from "./UserPointManage.vue?vue&type=script&lang=js"
export * from "./UserPointManage.vue?vue&type=script&lang=js"
import style0 from "./UserPointManage.vue?vue&type=style&index=0&id=41f5b144&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f5b144",
  null
  
)

export default component.exports